<template>
  <div>
    <div class="city-info">
      <!-- 0省教育厅 1市教育局 2区县教育局 3乡镇中心校/街道教育办 -->
      <div class="city-search" style="padding-top: 20px">
        <!-- <div class="city-title">
          <div class="span-pitch" ref="cityRef" @click="cityTitleClick()">
            选择城市
            <img
              class="active-img"
              src="@/assets/img/eduBigData/big-data-selected-city.png"
              alt=""
            />
          </div>
          <div class="span-no-pitch" ref="areaRef">
            选择区域
            <img
              class="active-img"
              src="@/assets/img/eduBigData/big-data-selected-city.png"
              alt=""
            />
          </div>
        </div> -->
      </div>
      <div class="city-or-area-list">
        <el-button
          type="text"
          class="city-item"
          @click="goBack()"
          v-show="isShowBack"
        >
          返回上级
        </el-button>
        <el-button
          type="text"
          v-for="(item, index) in cityList"
          :key="index"
          class="city-item"
          :class="{ active: isSelected == index }"
          @click="cityClick(item, index)"
          :title="item.regionName"
        >
          {{ item.regionName }}
        </el-button>
      </div>
      <map-education-bureau-info
        :eduDetail="eduDetail"
        @getSchoolList="getSchoolList"
        @eduOrSchoolChange="eduOrSchoolChange"
      ></map-education-bureau-info>
    </div>
  </div>
</template>

<script>
import mapEducationBureauInfo from "./mapEducationBureauInfo";
export default {
  name: "schoolSearchInfo",
  components: {
    mapEducationBureauInfo
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      isShowBack: false,
      selectEduBuresuType: "",
      backObject0: {}, // 省
      backObject1: {}, // 市
      backObject2: {}, // 区
      cityList: [],
      isSelected: 0,
      eduDetail: {}
    };
  },
  created() {},
  mounted() {
    this.cityTitleClick();
    this.getLoginEdu();
  },
  watch: {},
  methods: {
    //   点击选择城市标题
    cityTitleClick() {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      this.modifyBackShow(eduInfo.eduBuresuType);
      this.isSelected = 0;
      this.$emit("cityChange", this.eduInfo);
      this.$store.commit("updateEduIdResize", this.eduIdResize + 1);
      this.$store.commit("updateEduIdResizeInfo", this.eduInfo);
      this.getAreaList(this.eduInfo.eduId, this.eduInfo.eduBuresuType);
    },
    //   点击某个城市或某个区
    cityClick(item, index) {
      // console.log(item);
      if (index != 0) {
        // if (item.eduBuresuType < 4 ) {
        // 获取区县级列表
        this.isSelected = 0;
        this.selectEduBuresuType = item.eduBuresuType;

        if (this.selectEduBuresuType == 0) {
          this.backObject0 = item;
        } else if (this.selectEduBuresuType == 1) {
          this.backObject1 = item;
        } else if (this.selectEduBuresuType == 2) {
          this.backObject2 = item;
        } else if (this.selectEduBuresuType == 3) {
          this.backObject3 = item;
        }

        this.getAreaList(item.eduId, item.eduBuresuType);
        // } else {
        //   // 点击某个区县
        //   this.isSelected = index;
        //   this.getAreaList(item.eduId, item.eduBuresuType);
        // }
        this.modifyBackShow(item.eduBuresuType);
        this.$emit("cityChange", item || {});
        this.$store.commit("updateEduIdResize", this.eduIdResize + 1);
        this.$store.commit("updateEduIdResizeInfo", item);
      }
    },
    // 判断登录是哪一级教育局登录
    getLoginEdu() {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      let backObject = {
        contactAddress: eduInfo.contactAddress,
        eduBuresuName: eduInfo.eduBuresuName,
        eduBuresuType: eduInfo.eduBuresuType,
        eduCoordinate: eduInfo.eduCoordinate,
        eduId: eduInfo.eduId,
        regionCode: eduInfo.regionCode,
        regionName: eduInfo.regionName
      };
      if (eduInfo.eduBuresuType == 0) {
        this.backObject0 = backObject;
      } else if (eduInfo.eduBuresuType == 1) {
        this.backObject1 = backObject;
      } else if (eduInfo.eduBuresuType == 2) {
        this.backObject2 = backObject;
      } else if (eduInfo.eduBuresuType) {
        this.backObject3 = backObject;
      }
    },
    // 判断返回按钮是否显示
    modifyBackShow(eduBuresuType) {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      if (eduBuresuType == eduInfo.eduBuresuType) {
        this.isShowBack = false;
      } else {
        this.isShowBack = true;
      }
    },
    // 返回上级
    goBack() {
      // console.log(this.selectEduBuresuType);

      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));

      // console.log(eduInfo.eduBuresuType);
      if (this.selectEduBuresuType == 3) {
        if (eduInfo.eduBuresuType < 3) {
          this.selectEduBuresuType = 2;
          this.cityClick(this.backObject2, 1);
          if (eduInfo.eduBuresuType == 2) {
            this.isShowBack = false;
          }
        } else {
          this.isShowBack = false;
        }
      } else if (this.selectEduBuresuType == 2) {
        if (eduInfo.eduBuresuType < 2) {
          this.selectEduBuresuType = 1;
          this.cityClick(this.backObject1, 1);
          if (eduInfo.eduBuresuType == 1) {
            this.isShowBack = false;
          }
        } else {
          this.isShowBack = false;
        }
      } else if (this.selectEduBuresuType == 1) {
        if (eduInfo.eduBuresuType < 1) {
          this.selectEduBuresuType = 0;
          this.cityClick(this.backObject0, 1);
          if (eduInfo.eduBuresuType == 0) {
            this.isShowBack = false;
          }
        } else {
          this.isShowBack = false;
        }
      } else {
        backObject = {
          contactAddress: eduInfo.contactAddress,
          eduBuresuName: eduInfo.eduBuresuName,
          eduBuresuType: eduInfo.eduBuresuType,
          eduCoordinate: eduInfo.eduCoordinate,
          eduId: eduInfo.eduId,
          regionCode: eduInfo.regionCode,
          regionName: eduInfo.regionName
        };
        this.selectEduBuresuType = 0;
        this.isShowBack = false;
        this.cityClick(this.backObject, 1);
      }

      // this.getAreaList(backObject.eduId, backObject.eduBuresuType);
      // this.$emit("cityChange", backObject || {});
      // this.$store.commit("updateEduIdResize", this.eduIdResize + 1);
      // this.$store.commit("updateEduIdResizeInfo", backObject);
    },
    async getAreaList(eduId, eduBuresuType) {
      let req = {
        eduId: parseInt(eduId),
        educationBureauType: parseInt(eduBuresuType)
      };
      let self = this;
      let res = await self.$Http.getMapAreaList(req);
      if (res.code == 200) {
        if (res.data) {
          let data = res.data || [];
          let endData = data.pop();
          data.unshift(endData);
          if (eduBuresuType != 4) {
            self.cityList = data;
          }
          self.eduDetail = data[0] || {};
          // self.getTheSchoolButtonArea(data[0])
          if (this.eduInfo.eduBuresuType == 0) {
            if (data[1] && data[1].eduBuresuType == 1) {
              // 省教育厅
              // self.$refs.cityRef.className = "span-pitch"; //城市是选中的
              // self.$refs.areaRef.className = "span-no-pitch"; //区域是未选中的
            } else {
              // 市教育厅
              // self.$refs.areaRef.className = "span-pitch"; //区域是选中的
              // self.$refs.cityRef.className = "span-no-pitch"; //城市是未选中的
            }
          }
        }
      } else if (res.code == 101) {
        self.cityList = [];
        self.eduInfo = {
          eduBuresuName: "***"
        };
      } else {
        self.cityList = [];
        self.eduInfo = {
          eduBuresuName: "***"
        };
      }
    },
    // 根据选择的城市获取对应的教育局以及学校信息列表进行存储
    async getTheSchoolButtonArea(val) {
      let req = {
        eduId: parseInt(val.eduId),
        regionCode: parseInt(val.regionCode),
        educationBureauType: parseInt(val.eduBuresuType)
      };
      let self = this;
      let res = await self.$Http.getTheSchoolButtonArea(req);
      if (res.code == 200) {
        if (res.data) {
          let data = res.data || {
            getAllDirectlyAffiliatedEducationBureaus: [], //教育局数组
            getAllSchoolsOnTheEducationBureauMap: [] //学校数组
          };
          let schoolList = data.getAllSchoolsOnTheEducationBureauMap;
          schoolList = schoolList.map((item) => {
            item.type = "school";
            item.eduBuresuName = item.schoolName;
            item.id = "school" + item.schoolId;
            return item;
          });
          let eduList = data.getAllDirectlyAffiliatedEducationBureaus;
          eduList = eduList.map((item) => {
            item.type = "edu";
            item.id = "edu" + item.eduId;
            return item;
          });
          let list = schoolList.concat(eduList);
          list.reverse();
          list.map((item) => {
            let lngAndLat = item.schoolCoordinate || item.eduCoordinate;
            let arr = lngAndLat.split(",");
            item.markerPo = {
              lng: arr[0],
              lat: arr[1]
            };
            item.showInfoWindow = false;
            return item;
          });
          self.$store.commit("schoolAndEduList", list);
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    getSchoolList(list) {
      this.$emit("schoolList", list);
    },
    // 获取区县级列表
    getCountyList(list) {
      this.cityList = list.map((item) => {
        item.type = "county"; //市级列表
        return item;
      });
    },
    eduOrSchoolChange(obj) {
      this.$emit("eduOrSchoolChange", obj);
    }
  },
  computed: {
    eduIdResize() {
      return this.$store.state.eduIdResize;
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.city-info {
  margin-top: 15px;
  margin-left: 18px;
  background: url("~@/assets/img/schoolBaseInfo/school-bottom-border-height.png") center center
    no-repeat;
  background-size: 100% 100%;
  .city-search {
    display: flex;
    flex-direction: row;
    .city-title {
      margin-top: 15px;
      margin-left: 20px;
      width: 180px;
      height: 33px;
      line-height: 33px;
      font-size: 14px;
      background: url("~@/assets/img/schoolBaseInfo/key-file-bg.png") center center no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: row;
      div {
        &:first-child {
          cursor: pointer;
        }
      }
      .span-pitch {
        width: 50%;
        text-align: center;
        color: rgba(196, 240, 255, 1);
        position: relative;
        img {
          display: block;
          position: absolute;
          left: 8px;
          top: 4px;
        }
      }
      .span-no-pitch {
        width: 50%;
        text-align: center;
        color: rgba(196, 240, 255, 0.6);
        img {
          display: none;
        }
      }
    }
  }
  .city-or-area-list {
    width: 96%;
    margin: 0px 2%;
    height: 128px;
    overflow: scroll;
    scrollbar-width: none;
    .city-item {
      color: #c4f0ff;
      font-size: 16px;
      width: 23%;
      margin: 0px 1%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.active {
        color: #ffff00;
      }
    }
  }
}
.el-button + .el-button {
  margin-left: 0px;
}
</style>
